import React from 'react';
import PropTypes from 'prop-types';

import IconLooseSeatBackCushions from 'components/icons/PDPSellingAttributes/IconLooseSeatBackCushions';
import IconSeatsXComfortably from 'components/icons/PDPSellingAttributes/IconSeatsXComfortably';
import IconMediumFirmCushions from 'components/icons/PDPSellingAttributes/IconMediumFirmCushions';
import IconPlushCushions from 'components/icons/PDPSellingAttributes/IconPlushCushions';
import IconSolidWoodFrame from 'components/icons/PDPSellingAttributes/IconSolidWoodFrame';
import IconUltraDeepMaxComfort from 'components/icons/PDPSellingAttributes/IconUltraDeepMaxComfort';
import IconSleekSilhouetteSofa from 'components/icons/PDPSellingAttributes/IconSleekSilhouetteSofa';
import IconSleekSilhouetteChair from 'components/icons/PDPSellingAttributes/IconSleekSilhouetteChair';
import IconSleekSilhouetteSectional from 'components/icons/PDPSellingAttributes/IconSleekSilhouetteSectional';
import IconSleekSilhouetteGeneric from 'components/icons/PDPSellingAttributes/IconSleekSilhouetteGeneric';
import IconWithTooltipGreenguardGold from 'components/icons/PDPSellingAttributes/IconWithTooltipGreenguardGold';
import IconPlushComfort from 'components/icons/PDPSellingAttributes/IconPlushComfort';

const icons = {
  loose_seat___back_cushions: IconLooseSeatBackCushions,
  seats_4__comfortably: IconSeatsXComfortably,
  seats_3_4_comfortably: IconSeatsXComfortably,
  medium_firm_cushion: IconMediumFirmCushions,
  plush_cushions: IconPlushCushions,
  ultra_deep_for_maximum_comfort: IconUltraDeepMaxComfort,
  ultra_deep_for_max_comfort: IconUltraDeepMaxComfort,
  solid_wood_frame: IconSolidWoodFrame,
  sleek_silhouette_sofa: IconSleekSilhouetteSofa,
  sleek_silhouette_chair: IconSleekSilhouetteChair,
  sleek_silhouette_sectional: IconSleekSilhouetteSectional,
  sleek_silhouette_generic: IconSleekSilhouetteGeneric,
  greenguard_gold: IconWithTooltipGreenguardGold,
  soft_comfort: IconPlushComfort,
  medium_comfort: IconPlushComfort,
  firm_comfort: IconPlushComfort,
  ultra_plush_comfort: IconPlushComfort,
  standard_seat_depth: IconUltraDeepMaxComfort,
  ultra_seat_depth: IconUltraDeepMaxComfort,
};

const getIconName = (attribute, productType) => {
  let filename = attribute.toLowerCase().replace(/[^\w]/g, '_');
  if (attribute.startsWith('Sleek Silhouette')) {
    filename = `${filename}_${productType.toLowerCase()}`;
  }
  return filename;
};

const Attribute = ({ attribute, productType }) => {
  const Icon = icons[getIconName(attribute, productType)];
  if (!Icon) {
    return null;
  }

  return (
    <div className="flex items-center justify-start mx-0 my-[5px]">
      <Icon />
      <span className="text-base font-bold">{attribute}</span>
    </div>
  );
};

Attribute.propTypes = {
  attribute: PropTypes.string,
  productType: PropTypes.string,
};

export default Attribute;
